import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos equipamentos
 */
export class EquipamentoRequest {
    /**
     * Faz a requisição dos dados para os cards
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async CardsRequest(id: string, data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboard/${id}?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para os cards
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async allCardsRequest(data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboardGeral?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async daysRequest(id: string, data:string, card:string, flag:number, key: string, idEquipment: string):Promise<any>{
        try {
            let response = {
                data: []
            }
            if(key && idEquipment){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&key=${key}&idEquipment=${idEquipment}`);
            }else if(idEquipment){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&idEquipment=${idEquipment}`);
            }else if(key){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&key=${key}`);
            }else{
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async allDaysRequest(data:string, card:string, flag:number):Promise<any>{
        try {
            const response = await api.get(`/dashboardMonthGeral?date=${data}&card=${card}&flag=${flag}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async getStatusGeral(data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboardStatusGeral?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os equipamentos que o usuário tem acesso
    async getEquipamentosByUser(): Promise<any>{
        try {
            const Equipamentos = await api.get(`/me/authorizedPocosAndReservatoriosAndGrouppingsSeparated`);
            return Equipamentos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados em formato excel do equipamento
    async getExcel(id: string, datainicio: string, datafim: string, analysisMode: boolean, readingMode: boolean, methodOld: boolean, extension?: string): Promise<any>{
        const requestBody: any = {
            equipment: id,
            datainicio,
            datafim,
            analysisMode,
            methodOld,
        };

        if (methodOld === false) {
            requestBody.format = extension;
            requestBody.protected = readingMode;
        }
        
        try {
            const response = await api.post(`equipments/export/mappings/excel`, requestBody, {responseType: 'blob', timeout: 300000});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if(error.response?.status === 403){
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                throw new Error(json.message);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados em formato excel do equipamento
    async getReport(id: string, datainicio: string, datafim: string): Promise<any>{
        try {
            const response = await api.get(`sendReport/${datainicio}/${datafim}/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCities');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}
export const equipamentoRequest = new EquipamentoRequest();


/**
 * Classe que faz as requisições dos equipamentos
 */
export class ControlePerdasRequest {
    /**
     * Faz a requisição dos dados para os cards
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    
    async DonutChart( data: string): Promise<any> {
        
        interface Item {
            label: string;
            value: number;
        }

        interface DonutItem {
            id: number;
            name: string;
            key: string;
            itens: Item[];
            total: number;
            unit: string;
        }

        interface BalanceItemGroup {
            itens: Record<string, number>;
            total: number;
            unit: string;
        }

        type BalanceObject = Record<string, BalanceItemGroup>;


        try {
            const url = `/lossControl/${data}`;

            const response = await api.get(url);

            const balanceObject : BalanceObject = response.data.balance;

            // 🔹 OBJETO → ARRAY (NORMALIZAÇÃO)
            const donutArray: DonutItem[] = Object.entries(balanceObject).map(
                ([name, values], index) => ({
                    id: index,
                    name,
                    key: name,
                    itens: Object.entries(values.itens || {}).map(([label, value]) => ({
                                label,
                                value
                            })),
                    total: values.total,
                    unit: values.unit
                })
            );

            return donutArray;

        } catch (error: any) {
            if (error.response?.status === 401) {
                throw Object.assign(
                    new Error(i18n.t('request-errors.unauthenticated')),
                    { status: 401 }
                );
            } else if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    
    async CardsRequest(data: string): Promise<any> {
        interface CardApiItem {
            production: number;
            unit: string;
        }

        interface Card {
            id: number;
            name: string;
            key: string;
            production: number; // número direto
            unit: string;       // string direta
            Active: boolean;
            type: number;
        }


        try {
            const url = `/lossControl/${data}`;

            const response = await api.get(url);

            const cardsObject: Record<string, CardApiItem> = response.data.cards;

            const cardsArray: Card[] = Object.entries(cardsObject).map(
                ([name, values], index) => ({
                    id: index,
                    name,
                    key: name,
                    production: values.production,
                    unit: values.unit,
                    Active: true,
                    type: 0
                })
            );

            // console.log(cardsArray)

            return cardsArray;

        } catch (error: any) {
            if (error.response?.status === 401) {
                throw Object.assign(
                    new Error(i18n.t('request-errors.unauthenticated')),
                    { status: 401 }
                );
            } else if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}
export const controlePerdasRequest = new ControlePerdasRequest();